<template>
  <v-dialog
    v-model="computedBikeparkSignsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('bikepark', 'signs', false);
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedName }} {{ computedLoc }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedBikeparkSignsGeoJsonFeature"
          :loading="computedBikeparkSignssLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Image</td>
              <td>
                <span
                  v-if="
                    computedImageUrl !=
                      'https://api2.alchemymapping.com/images/null'
                  "
                >
                  <img
                    style="max-height: 90vh; max-width: 90vw;"
                    :src="computedImageUrl"
                  />
                </span>
              </td>
            </tr>
            <tr>
              <td>Trail Name</td>
              <td>
                <v-select
                  :items="computedUniqueTrailNames"
                  ref="signs_trail_name"
                  v-model="props.item.properties.trail_name"
                  :label="props.item.properties.trail_name"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Location</td>
              <td>
                <v-select
                  :items="computedUniqueLocations"
                  ref="signs_sign_loc"
                  v-model="props.item.properties.sign_loc"
                  :label="props.item.properties.sign_loc"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Feature Number</td>
              <td>
                <v-text-field
                  ref="signs_feat_num"
                  v-model="props.item.properties.feat_num"
                  :label="props.item.properties.feat_num"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <v-textarea
                  name="signs_comments"
                  ref="signs_comments"
                  v-model="props.item.properties.comments"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
            <tr>
              <td>Last Edit</td>
              <td v-if="disable_edit">
                {{ props.item.properties.lasteditor }}
              </td>
              <td v-if="!disable_edit">{{ computedAuth.profile.email }}</td>
            </tr>
            <tr>
              <td>Last Edit</td>
              <td v-if="disable_edit">{{ props.item.properties.modified }}</td>
              <td v-if="!disable_edit">{{ getNormalDate(Date.now()) }}</td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditBikeparkSignsGeoJson({
                      trail_name: $refs.signs_trail_name.value,
                      sign_loc: $refs.signs_sign_loc.value,
                      feat_num: $refs.signs_feat_num.value,
                      comments: $refs.signs_comments.value,
                      lasteditor: computedAuth.profile.email
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('bikepark', 'signs', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              confirm_delete = false;
              disable_edit = true;
              methodDeleteBikeparkSignsGeoJson();
              methodToggleSingleLayer('bikepark', 'signs', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      disable_edit: true,
      confirm_delete: false,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true
    };
  },
  computed: {
    computedName() {
      let res;
      if (this.computedBikeparkSignsVisibility) {
        const points = this.$store.state.mapLayers.bikepark.layers.signs.geojson
          .features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedBikeparkSignsId
        );
        res = result[0].properties.trail_name;
      }
      return res;
    },
    computedLoc() {
      let res;
      if (this.computedBikeparkSignsVisibility) {
        const points = this.$store.state.mapLayers.bikepark.layers.signs.geojson
          .features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedBikeparkSignsId
        );
        res = result[0].properties.sign_loc;
      }
      return res;
    },
    computedUniqueTrailNames() {
      const trailNames = this.$store.state.mapLayers.bikepark.layers.signs
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < trailNames.length; i++) {
        a.push(trailNames[i].properties.trail_name); // push all trails into array a
      }

      return a.unique().sort(); // returns sorted unique trail names
    },
    computedUniqueLocations() {
      const locations = this.$store.state.mapLayers.bikepark.layers.signs
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].properties.sign_loc !== null) {
          a.push(locations[i].properties.sign_loc); // push all sign locations into array a
        }
      }
      return a.unique().sort(); // returns sorted unique sign locations
    },
    computedBikeparkSignsGeoJsonFeature() {
      let res;
      if (this.$store.state.mapLayers.bikepark.layers.signs.geojson.features) {
        const points = this.$store.state.mapLayers.bikepark.layers.signs.geojson
          .features;
        const result = points.filter(
          item => item.properties.id == this.computedBikeparkSignsId
        );
        res = result;
      }
      return res;
    },
    computedBikeparkSignsVisibility() {
      return this.$store.state.mapLayers.bikepark.layers.signs.visibility
        .singleView;
    },
    computedBikeparkSignssLoading() {
      return this.$store.state.mapLayers.bikepark.layers.signs.loading;
    },
    computedBikeparkSignsId() {
      return this.$store.state.mapLayers.bikepark.layers.signs.visibility
        .singleId;
    },
    computedImageUrl() {
      return (
        "https://api2.alchemymapping.com/images/" +
        this.$store.state.ui.image.filename.filename[0].filename
      );
    },
    computedImageHack() {
      return this.$store.state.ui.image.filename.filename[0].filename;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetBikeparkSignsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/bikepark/signs",
        dept: "bikepark",
        layer: "signs",
        token: this.computedAuthToken
      });
    },
    methodEditBikeparkSignsGeoJson(data) {
      this.$store.dispatch("actionEditGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/bikepark/signs/" +
          this.computedBikeparkSignsId,
        dept: "bikepark",
        layer: "signs",
        token: this.computedAuthToken,
        payload: data
      });
    },
    methodDeleteBikeparkSignsGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/signs/" +
            this.computedBikeparkSignsId,
          dept: "bikepark",
          layer: "signs",
          token: this.computedAuthToken
        })
        .then(
          setTimeout(() => {
            this.methodGetBikeparkSignsGeoJson();
          }, 250)
        );
    },
    methodGetBikeparkImage() {
      this.$store.dispatch("actionGetImage", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/bikepark/signs/image/" +
          this.computedBikeparkSignsId,
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.bikepark.layers.signs.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetBikeparkSignsGeoJson();
        this.methodGetBikeparkImage();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.bikepark.layers.signs.geojson": function(newValue) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
